var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{staticClass:"breadcrumb"},[_c('ul',{staticClass:"nav-breadcrumb"},_vm._l((_vm.breadcrumbs),function(crumb,index){return _c('li',{key:index,staticClass:"breadcrumb-item"},[(index + 1 === _vm.breadcrumbs.length)?_c('span',[_vm._v("\n        "+_vm._s(_vm.labelBread({ index, crumb }))+"\n      ")]):_c('hot-link',_vm._b({},'hot-link',{
          label: _vm.labelBread({ index, crumb }),
          href: crumb.url,
          type: 'secondary',
        },false))],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }